export default "__VITE_ASSET__uy5AGNpF__"